import { DEFAULT_CONFETTI_DURATION } from '@snowball-tech/common/constants'
import { combine } from 'zustand/middleware'
import { createWithEqualityFn as create } from 'zustand/traditional'

const useHomeStore = create(
  combine(
    {
      recycleConfettis: true,
      runConfettis: false,
    },
    (set) => ({
      startConfettis: (duration = DEFAULT_CONFETTI_DURATION) => {
        set({ recycleConfettis: true, runConfettis: true })

        if (duration > 0) {
          setTimeout(() => {
            set({ recycleConfettis: false })

            setTimeout(() => set({ runConfettis: false }), 15_000)
          }, duration)
        }
      },
      stopConfettis: () => {
        set({ recycleConfettis: false })

        setTimeout(() => set({ runConfettis: false }), 15_000)
      },
    }),
  ),
)

export default useHomeStore
